import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'FactoryOverviewHelp',
  setup(__props) {

const { t } = useI18n();

return { __sfc: true,t }
}

})